/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { MeLikeArticleResponse } from "./MeLikeArticleResponse";

export type MeLikeArticleResponseApiRespoonse = {
  data?: MeLikeArticleResponse;
  status?: MeLikeArticleResponseApiRespoonse.status;
  message?: string;
  errors?: Record<string, Array<string>>;
};

export namespace MeLikeArticleResponseApiRespoonse {
  export enum status {
    SUCCESS = "success",
    ERROR = "error",
  }
}
